import React, { useState } from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const ApprovalList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowClick,
  columnVisibilityModel
}) => {

  //alert('a');

  if( columnVisibilityModel === null) {


    columnVisibilityModel = {
      // Hide columns status and traderName, the other columns will remain visible
      id: false,
      apprUuid: false,
      docuUuid: false,
      docuCd: false,
      docuTyp: false,
    }
  }

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          autoHeight
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '결재_리스트' },
          }}
          loading={loading}
          onRowClick={handleRowClick}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}

          // pageSize={pageSize}
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          // rowsPerPageOptions={[5, 10, 20, 50, 100]}
          // pagination
        />
      </div>
    </div>
  );
};

export default ApprovalList;
